
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './MemberTodoEntryV2.html?raw';
import "../../../moreCore/UI/CheckBox/CheckBox";
import "../../../moreCore/UI/DateInput/DateInput";
import "../../../moreCore/UI/StaticTable/StaticTable";
import { TodoListTypes } from "../../_loadingHelpers/TodoList"
import _StatefulSection from '../../../moreCore/UI/_StatefulSection/_StatefulSection';
import _TabEnabledMixin from '../../../moreCore/UI/Tabbing/_TabEnabledMixin';
import Tooltip from '../../../moreCore/UI/Floating/Tooltip';
import { ToasterHelpers } from "../../../more/Helpers";
import SearchSelect from '../../../moreCore/UI/SearchSelect/SearchSelect';
class MemberTodoEntryV2 extends compose(_StatefulSection, _TabEnabledMixin) {
    templateString: any = template;

    sourceClass: HTMLSpanElement;
    memberName: HTMLSpanElement;

    //private entityId: string = null;
    private todoStatus: MdsLax<InstanceType<typeof SearchSelect>>;
    private descriptionTooltipContainer: HTMLElement;

    private entityData: TodoListTypes.TodoMemberEntity = null;

    private _setStatusValues(values: Array<TodoListTypes.TodoStatus>): void {
        let currentStatus = this.getAttributeValue("ref_todo_status");
        currentStatus["description"] = this.getAttributeValue("status");
        currentStatus["coloration"] = this.getAttributeValue("statusColor");
        let allowedFinishing = this.getAttributeValue("is_allowed_finishing");
        let filteredValues = values.filter((value) => {
            return !value.is_finished || allowedFinishing;
        });

        this.todoStatus.setData(currentStatus, filteredValues, true);
    }

    afterSetData() {
        let data = this.sourceData as TodoListTypes.TodoMemberEntity;

        this.entityId = data.ID;


        this.todoStatus.setLabel(data.task_description ? data.task_description : data.parent_task_description);
        this._setStatusValues(data.statusValues);

        let tooltip = new Tooltip();

        tooltip.setup({
            content: data.note,
            heading: this.todoStatus.getLabel(),
            targetnode: this.descriptionTooltipContainer,
            enableClick: true
        });

        this.UiModder.domConstruct.empty(this.sourceClass);
        switch (data.Classname) {
            case "todo_member_evis_user":
                this.UiModder.domConstruct.place(this.createFontawesomeIcon("fas fa-user w3-text-green"), this.sourceClass);
                this.memberName.textContent = data.memberName;
                break;

            case "todo_member_associate_grouped":
                this.UiModder.domConstruct.place(this.createFontawesomeIcon("fas fa-users w3-text-blue-gray"), this.sourceClass);
                this.memberName.textContent = data.groupName;
                break;
        }

        this._setDataBasedStyle();
    }

    private _setDataBasedStyle() {
        let data = this.currentData as TodoListTypes.TodoMemberEntityV2;
        let currentEmployeeId = window.sessionInfo?.sessionData?.CurrentEmployeeId;
        let isAllowedToModify: boolean;

        switch (data.Classname) {
            case "todo_member_evis_user":
                isAllowedToModify = data.memberID == currentEmployeeId;
                break;
            case "todo_member_associate_grouped":
                isAllowedToModify = data.is_in_group;
                break;
            default:
                isAllowedToModify = false;
        }

        this.hideNode(this.descriptionTooltipContainer, !(data.note && isAllowedToModify))

        let currentStatus: TodoListTypes.TodoStatus = this.todoStatus.getValue(true);
        let isFinishedCurrentStatus = currentStatus ? currentStatus.is_finished : false;
        let isTodoFinished = data.is_todo_finished;
        this.todoStatus.setReadonly(!isAllowedToModify || isFinishedCurrentStatus || isTodoFinished);

        //this.UiModder.domClass.toggle(this.todoStatus.domNode, "strike", data.is_finished === true);

        if (isAllowedToModify) {
            this.UiModder.domClass.toggle(this.domNode, "border accentBorder accentTransparentBG", isFinishedCurrentStatus !== true);
        } else {
            this.UiModder.domClass.toggle(this.domNode, "border secondaryBorder", true);
        }
    }

    private _onClickDescription(evt: MouseEvent) {
        //evt.stopPropagation();

        //let data = this.sourceData as TodoListTypes.TodoMemberEntity;

        //let tooltip = new Tooltip();

        //tooltip.setup({
        //    content: data.note,
        //    heading: this.cbIsFinished.getLabel(),
        //    targetnode: this.descriptionTooltipContainer,
        //    enableClick: true
        //});

        
    }

    private _saveTimeoutHandle: any = null;
    protected onDirtyChange(newState: boolean) {
        console.log(this.id + " dirtyChange", newState, this.currentData);

        if(newState) this.saveData();
    }

    private saveData(): void {

        if (this._saveTimeoutHandle) {
            clearTimeout(this._saveTimeoutHandle);
        }

        this._saveTimeoutHandle = setTimeout(lang.hitch(this, this._save), 100);
    }

    private _save(): void {

        this.StandbyStart();

        let data = {
            "todoMemberID": this.entityId,
            ...this.changedData
        };

        this.RequestManager.callfunction("Webtool_API_TodoList__SaveTodoMemberV2", data, lang.hitch(this, this._onSaveData_Response), lang.hitch(this, this._onSaveData_Error));

    }


    private _onSaveData_Response(response): void {
        //this.StandbyStop();
        this.resetDirty();

        this.emit("saved", true);

        this.StandbyStop();

        this.showToast({
            title: this.translations["General__SaveSuccess"],
            iconClass: ToasterHelpers.ToasterIcons.confirmCheck
        });

    }

    private _onSaveData_Error(error: more.requestErrorMessage) {
        this.StandbyStop();

        this.showToast({
            title: this.translations["General__ProcessFailed"],
            iconClass: ToasterHelpers.ToasterIcons.error,
            message: error.Message
        });

        this.rollback();
    }
    
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.todoStatus.setMultiselect(false);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(MemberTodoEntryV2);